module.exports = __webpack_public_path__ + "static/media/Rounds-03.57d13eab.png";